import React, { useContext, useState } from 'react'
import LanguageContext from '../../contexts/LanguageContext'
import './ContactForm.css'


const ContactForm = ({language, txtAlign}) => { 
const {form,textarea,btn,selectPlaceholder} = language.contact
const context = useContext(LanguageContext)
const [formState, setFormState] = useState({
    submitting: false,
    submitted: false,
    error: false
})

const encode = (data) => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&")
}

const handleSubmit = (e) => {
    e.preventDefault()
    setFormState({ submitting: true, submitted: false, error: false })
    
    const formData = new FormData(e.target)
    const data = {}
    formData.forEach((value, key) => {
        data[key] = value
    })

    fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": "contact-us", ...data })
    })
    .then((response) => {
        if (response.ok || response.status === 200) {
            setFormState({ submitting: false, submitted: true, error: false })
            e.target.reset()
            setTimeout(() => {
                setFormState({ submitting: false, submitted: false, error: false })
            }, 5000)
        } else {
            throw new Error('Submission failed')
        }
    })
    .catch((error) => {
        console.error('Form submission error:', error)
        // Check if we're in development mode
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
            console.warn('Note: Netlify forms only work in production. This is expected in local development.')
            // Show success message in dev for testing UI
            setFormState({ submitting: false, submitted: true, error: false })
            e.target.reset()
            setTimeout(() => {
                setFormState({ submitting: false, submitted: false, error: false })
            }, 5000)
        } else {
            // Real error in production
            setFormState({ submitting: false, submitted: false, error: true })
            setTimeout(() => {
                setFormState({ submitting: false, submitted: false, error: false })
            }, 5000)
        }
    })
}

const getSubmitText = () => {
    if (formState.submitting) {
        return context.language === 'hebrew' ? 'שולח...' : 
               context.language === 'arabic' ? 'جاري الإرسال...' : 'Sending...'
    }
    return btn.name
}

return(
<div className="contact-form-wrapper">
    <form className={`contact-form`} style={{textAlign:txtAlign}} onSubmit={handleSubmit} name="contact-us">
    <input type="hidden" name="form-name" value="contact-us" />
        {form.map((item,i) => (
            <React.Fragment key={i}>
            <label>{item.value}</label>
            {item.type === 'select' ? (
                <select name={item.name} className="form-select" required disabled={formState.submitting}>
                    <option value="">{selectPlaceholder}</option>
                    {item.options.map((option, idx) => (
                        <option key={idx} value={option}>{option}</option>
                    ))}
                </select>
            ) : (
                <input 
                    type={item.type} 
                    className="form-input" 
                    name={item.name}
                    placeholder={item.placeholder}
                    required
                    disabled={formState.submitting}
                />
            )}
            </React.Fragment>
        ))}
        <label>{textarea.name}</label>
        <textarea 
            name="message" 
            cols="30" 
            rows="6" 
            placeholder={textarea.placeholder}
            required
            disabled={formState.submitting}
        ></textarea>
        <input 
            type="submit" 
            value={getSubmitText()} 
            className={`cwhite ${context.language}`}
            disabled={formState.submitting}
        />
    </form>
    
    {formState.submitted && (
        <div className="form-message success">
            {context.language === 'hebrew' ? '✓ ההודעה נשלחה בהצלחה!' : 
             context.language === 'arabic' ? '✓ تم إرسال الرسالة بنجاح!' : 
             '✓ Message sent successfully!'}
        </div>
    )}
    
    {formState.error && (
        <div className="form-message error">
            {context.language === 'hebrew' ? '✗ אירעה שגיאה. אנא נסה שוב.' : 
             context.language === 'arabic' ? '✗ حدث خطأ. يرجى المحاولة مرة أخرى.' : 
             '✗ An error occurred. Please try again.'}
        </div>
    )}
</div>
)
}

export default ContactForm